import React from "react"
import { FaqListWrapper } from "./faq-list.style"

const FaqList = ({ children }) => {
  return <FaqListWrapper className="faq-list">{children}</FaqListWrapper>
}

export default FaqList
